import { ActionContext } from 'vuex'
import apiAdminUser from '@/api/admin/user'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IUserState } from './state';
import { ApiResultCode } from '@/models/response/AlrBase';
import { AloDbUser } from '@/models/alodb/AloDbUser';
import { AloError } from '@/models/alo/AloError';
import { AloBaseArray } from '@/models/alo/AloBaseArray';
import { router } from '@/mainjs.js'
import { AloDbRoleMapping } from '@/models/alodb/AloDbRoleMapping'
import { WobAdminChanged } from '@/models/wob/WobAdminChanged'
import {i18n} from '@/locale/vueI18n'

export class UserAction {
   
  public [types.USER_REQUEST](context: ActionContext<IUserState, IRootState>) {    
    return new Promise((resolve, reject) => {
        context.commit(types.USER_REQUEST)
        apiAdminUser
          .getUsers()
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const userArray = resp.data.data as AloBaseArray<AloDbUser>
              context.commit(types.USER_SUCCESS, userArray.items)
              resolve(userArray.items)
            } else {
              context.commit(types.USER_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(resp => {
            context.commit(types.USER_ERROR)
            reject()
          })
      })
  }

  public [types.USER_ENSURE_LIST](context: ActionContext<IUserState, IRootState>) {
    if(context.state.users.length == 0) {
        return context.dispatch(types.USER_REQUEST)
    }
    else {
        return new Promise((resolve, reject) => {            
            resolve(context.state.users)            
        })
    }    
  }

  public [types.USER_SELECT_DETAIL](context: ActionContext<IUserState, IRootState>, itemId:number) {        
    return new Promise((resolve, reject) => {
      const user = context.getters.usersById[itemId] as AloDbUser      
      if(user) {        
        if(user.detailLoaded) {
          context.commit(types.USER_SELECT_DETAIL,user)
          resolve(user)
        }
        else{
          context.dispatch(types.USER_SELECT_DETAIL_REQUEST,itemId).then((ens) => {
            context.commit(types.USER_SELECT_DETAIL,ens)
            resolve(ens)
          })
        }
      }    
      else{
        const newUser = new AloDbUser()
        context.commit(types.USER_SELECT_DETAIL,new AloDbUser())
        resolve(newUser)
      }
    })
  }

  public [types.USER_SELECT_DETAIL_REQUEST](context: ActionContext<IUserState, IRootState>, itemId:number) {
    return new Promise((resolve, reject) => {
        context.commit(types.USER_SELECT_DETAIL_REQUEST, itemId)
        apiAdminUser
          .getUser(itemId)
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const user = resp.data.data as AloDbUser
              context.commit(types.USER_SELECT_DETAIL_SUCCESS, user)
              context.commit(types.USER_SELECT_DETAIL,user)
              resolve(user)
            } else {
              context.commit(types.USER_SELECT_DETAIL_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(() => {
            context.commit(types.USER_SELECT_DETAIL_ERROR)
            reject()
          })
      })
  }

  public [types.USER_SAVE_REQUEST](context: ActionContext<IUserState, IRootState>) {    
    return new Promise((resolve, reject) => { 
        const tryRedirect = !context.state.modifiedAdmUser.id
        context.commit(types.USER_SAVE_REQUEST,context.state.modifiedAdmUser.USR_NOM)
        apiAdminUser
          .saveUser(context.state.modifiedAdmUser)                    
          .then(resp => {                                
            if (resp.data.resultCode == ApiResultCode.Ok) {
              const user = resp.data.data as AloDbUser            
              context.commit(types.USER_SELECT_DETAIL_SUCCESS, user)
              context.commit(types.USER_SELECT_DETAIL,user)               
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:user.USR_NOM}))
              if(tryRedirect && router.app.$route.name === 'NewUser') router.push({name:'EditUser',params:{userid:user.id!.toString()}})
              resolve(user)
              
            } else {
              console.error("ATTENTION une reponse Code 200 contient une erreur")
              context.commit(types.USER_SAVE_ERROR)
              const error = resp.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))              
              console.error(error)
              reject(error)
            }
          })          
          .catch((error) => {
            context.commit(types.USER_SAVE_ERROR)
            if(error.response){
              const er = error.response.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
              console.error(er)
              reject(er)
            }   
            else{         
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
              reject()
            }            
          })
      })
  }

  public [types.USER_DELETE_REQUEST](context: ActionContext<IUserState, IRootState>) {
    return new Promise<void>((resolve, reject) => {      
      const usrId = context.state.originalAdmUser.USR_ID!
      const usrNom = context.state.originalAdmUser.USR_NOM
      context.commit(types.USER_DELETE_REQUEST, usrNom)
      apiAdminUser
        .deleteUser(usrId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            context.commit(types.USER_DELETE_SUCCESS, usrId)
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.DeleteOk',{item:usrNom}))               
            if (router.app.$route.name === 'EditUser' && context.state.originalAdmUser.USR_ID! == usrId) {
              router.push({ name: 'NewUser' })
            }
            resolve()
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.USER_DELETE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.USER_DELETE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
            console.error(er)
            reject(er)
          } else {
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
            reject()
          }
        })
    })
  }

  public [types.USER_EXTERNAL_UPDATE](
    context: ActionContext<IUserState, IRootState>,wob: WobAdminChanged<AloDbUser>
  ) {
    return new Promise<void>((resolve, reject) => {            
      context.commit(types.USER_EXTERNAL_UPDATE, wob)
      resolve()
    })
  }

  public [types.USER_ROLEMAPPING_EXTERNAL_UPDATE](
    context: ActionContext<IUserState, IRootState>,wob: WobAdminChanged<AloDbRoleMapping>
  ) {
    return new Promise<void>((resolve, reject) => {                  
      context.dispatch(types.ADMINMISSION_ROLEMAPPING_EXTERNAL_UPDATE, wob)
      if(wob.actionType == "Deleted") {
        context.commit(types.USER_REMOVE_ROLEMAPPING_SUCCESS, wob.oldAloDbItem)
      }
      else{
        context.commit(types.USER_ADD_ROLEMAPPING_SUCCESS, wob.newAloDbItem)
      }       
      resolve()
    })
  } 

  public [types.USER_UPDATE_MODIFIED_ADM](context: ActionContext<IUserState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.USER_UPDATE_MODIFIED_ADM,newProperties)
      resolve(context.state.modifiedAdmUser)
    })
  }
  
  public [types.USER_CANCEL_MODIFIED_ADM](context: ActionContext<IUserState, IRootState>) {        
    return new Promise((resolve, reject) => {
      context.commit(types.USER_SELECT_DETAIL,context.state.originalAdmUser)
      resolve(context.state.modifiedAdmUser)
    })
  }

  public [types.USER_UPDATE_FILTER_ADM](context: ActionContext<IUserState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.USER_UPDATE_FILTER_ADM,newProperties)
      resolve(context.state.adminFilter)
    })
  }
  
  public [types.USER_ENSURE_ROLEMAPPING](context: ActionContext<IUserState, IRootState>, {itemId,explicit}:{itemId:number,explicit:boolean}) {
    if(context.state.modifiedAdmUserRolesMapping.length == 0 || context.state.modifiedAdmUserRolesMapping[0].USR_ID != itemId) {
        return context.dispatch(types.USER_ROLEMAPPING_REQUEST,{itemId,explicit})
    }
    else {
        return new Promise((resolve, reject) => {            
            resolve(context.state.modifiedAdmUserRolesMapping)            
        })
    }    
  }

  public [types.USER_ROLEMAPPING_REQUEST](context: ActionContext<IUserState, IRootState>, {itemId,explicit}:{itemId:number,explicit:boolean}) {
    return new Promise((resolve, reject) => {
        context.commit(types.USER_ROLEMAPPING_REQUEST, itemId)
        apiAdminUser
          .getUserRoleMap(itemId,explicit)
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const rolesMappingArray = resp.data.data as AloBaseArray<AloDbRoleMapping>
              context.commit(types.USER_ROLEMAPPING_SUCCESS, rolesMappingArray.items)
              resolve(rolesMappingArray.items)
            } else {
              context.commit(types.USER_ROLEMAPPING_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(resp => {
            context.commit(types.USER_ROLEMAPPING_ERROR)
            reject()
          })
      })
  }

  public [types.USER_ADD_ROLEMAPPING_REQUEST](context: ActionContext<IUserState, IRootState>, {usrId,mapObject,mapId,rolKey}:{usrId:number,mapObject:string,mapId:number,rolKey:string}) {
    return new Promise((resolve, reject) => {
        context.commit(types.USER_ADD_ROLEMAPPING_REQUEST, {usrId,mapObject,mapId,rolKey})
        apiAdminUser
          .addUserRoleMapping({usrId,mapObject,mapId,rolKey})
          .then(resp => {                                
            if (resp.data.resultCode == ApiResultCode.Ok) {
              const mapping = resp.data.data as AloDbRoleMapping            
              context.commit(types.USER_ADD_ROLEMAPPING_SUCCESS, mapping)                            
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:mapping.libelle}))                      
              resolve(mapping)
              
            } else {
              console.error("ATTENTION une reponse Code 200 contient une erreur")
              context.commit(types.USER_ADD_ROLEMAPPING_ERROR,mapObject)
              const error = resp.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))             
              console.error(error)
              reject(error)
            }
          })          
          .catch((error) => {
            context.commit(types.USER_ADD_ROLEMAPPING_ERROR,mapObject)
            if(error.response){
              const er = error.response.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
              console.error(er)
              reject(er)
            }   
            else{         
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
              reject()
            }            
          })
      })
  }  
  
  public [types.USER_REMOVE_ROLEMAPPING_REQUEST](context: ActionContext<IUserState, IRootState>, {usrId,mapObject,mapId,rolKey}:{usrId:number,mapObject:string,mapId:number,rolKey:string}) {
    return new Promise((resolve, reject) => {
        context.commit(types.USER_REMOVE_ROLEMAPPING_REQUEST, {usrId,mapObject,mapId,rolKey})
        apiAdminUser
          .removeUserRoleMapping({usrId,mapObject,mapId,rolKey})
          .then(resp => {                                
            if (resp.data.resultCode == ApiResultCode.Ok) {
              const mapping = resp.data.data as AloDbRoleMapping            
              context.commit(types.USER_REMOVE_ROLEMAPPING_SUCCESS, mapping)              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.DeleteOk',{item:mapping.libelle}))                                    
              resolve(mapping)
              
            } else {
              console.error("ATTENTION une reponse Code 200 contient une erreur")
              context.commit(types.USER_REMOVE_ROLEMAPPING_ERROR,mapObject)
              const error = resp.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorDelete',{error:error.errorMessage}))
              console.error(error)
              reject(error)
            }
          })          
          .catch((error) => {
            context.commit(types.USER_REMOVE_ROLEMAPPING_ERROR,mapObject)
            if(error.response){
              const er = error.response.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorDelete',{error:er.errorMessage}))
              console.error(er)
              reject(er)
            }   
            else{         
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnDelete'))
              reject()
            }            
          })
      })
  } 

  public [types.USER_CHANGE_PASSWORD_REQUEST](context: ActionContext<IUserState, IRootState>, {usrId,oldPassword,newPassword}:{usrId:number,oldPassword:string|null,newPassword:string}) {
    return new Promise<void>((resolve, reject) => {
        context.commit(types.USER_CHANGE_PASSWORD_REQUEST, usrId)
        apiAdminUser
          .changePassword({usrId,oldPassword,newPassword})
          .then(resp => {                                
            if (resp.data.resultCode == ApiResultCode.Ok) {                        
              context.commit(types.USER_CHANGE_PASSWORD_SUCCESS,usrId)              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.PasswordSaveOk'))
              resolve()
              
            } else {
              console.error("ATTENTION une reponse Code 200 contient une erreur")
              context.commit(types.USER_CHANGE_PASSWORD_ERROR,usrId)
              const error = resp.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.PasswordErrorSave',{error:error.errorMessage}))
              console.error(error)
              reject(error)
            }
          })          
          .catch((error) => {
            context.commit(types.USER_CHANGE_PASSWORD_ERROR,usrId)
            if(error.response){
              const er = error.response.data.data as AloError                            
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.PasswordErrorSave',{error:er.errorMessage}))
              console.error(er)
              reject(er)
            }   
            else{         
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.PasswordErrorOnSave'))
              reject()
            }            
          })
      })
  } 
}

export default util.classToObject(UserAction)